import MuiDrawer from '@mui/material/Drawer'
import { useMemo, useRef } from 'react'
import { Divider, List } from '@mui/material'
import { navigationMenuRoutes } from '../../../configs/navigation-menu-routes'
import NavigationMenuItems from './NavigationMenuItems'
import {
  NavigationRoute,
  NavigationRouteItem,
  RoutePermissions
} from '../../../types/navigation-meny-types'
import useAppStore from '../../../stores/app'
import useOnClickOutside from '../../../hooks/useOnClickOutside'

const NavigationMenu = () => {
  const { isOpenNavigationMenu, switchNavigationMenu, permissions } = useAppStore()
  const drawerRef = useRef<HTMLDivElement>(null)

  const handleClickOutside = (e: Event) => {
    const drawerButtonElement = document.getElementById('drawer-button')
    if (isOpenNavigationMenu && !drawerButtonElement?.contains(e.target as Node)) {
      switchNavigationMenu()
    }
  }

  useOnClickOutside(drawerRef, handleClickOutside)

  const hasPermission = (routePermission: RoutePermissions) => typeof routePermission === 'string' ? Object.hasOwn(permissions, routePermission) : routePermission

  const routes = useMemo(() => getNewRoutes(hasPermission), [permissions])

  const handleOnCloseMenu = () => {
    if (isOpenNavigationMenu) {
      switchNavigationMenu()
    }
  }

  return (
    <MuiDrawer
      PaperProps={{ className: isOpenNavigationMenu ? 'open' : '' }}
      variant="permanent"
      ref={drawerRef}
      open={isOpenNavigationMenu}>
      <Divider />
      <List>
        {routes.map(route => <NavigationMenuItems route={route} key={route.label} open={isOpenNavigationMenu} onCloseMenu={handleOnCloseMenu} />)}
      </List>
      <Divider />
    </MuiDrawer>
  )
}

function getNewRoutes(hasPermission: (routePermission: RoutePermissions) => boolean): NavigationRouteItem {
  const new_routes: NavigationRouteItem = []
  navigationMenuRoutes.forEach(route => {
    if (!('children' in route)) {
      if (hasPermission(route.permissions)) {
        new_routes.push(route)
      }
    } else {
      const route_children: NavigationRoute[] = []
      route.children.forEach(route_child => {
        if (hasPermission(route_child.permissions)) {
          route_children.push(route_child)
        }
      })

      if (route_children.length > 0) {
        if (route_children.length === 1) {
          new_routes.push(route_children[0])
        } else {
          new_routes.push({
            ...route,
            children: route_children
          })
        }
      }
    }
  })
  return new_routes
}

export default NavigationMenu
